const Footer = () => (
  <footer className="bg-[#1f170f] py-12 border-t border-cyan-500/30">
    <div className="max-w-7xl mx-auto px-4">
      <div className="grid md:grid-cols-3 gap-10 mb-10">
        <div>
          <h3 className="text-xl font-black glow mb-4 rajdhani tracking-wide">CYBER SECURE INDIA</h3>
          <p className="text-gray-400 text-sm leading-7">Official Cyber Awareness &amp; Government Resource Platform for Citizens and Law Enforcement across India.</p>
        </div>
        <div>
          <h4 className="text-sm font-bold text-cyan-300 mb-4 mono uppercase tracking-widest">Quick Links</h4>
          <div className="grid grid-cols-2 gap-2 text-sm text-gray-400">
            <a href="https://cybercrime.gov.in" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">Cybercrime Portal</a>
            <a href="https://cert-in.org.in" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">CERT-In</a>
            <a href="https://i4c.mha.gov.in" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">I4C</a>
            <a href="https://sancharsaathi.gov.in" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">Sanchar Saathi</a>
            <a href="https://ceir.gov.in" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">CEIR Portal</a>
            <a href="https://nciipc.gov.in" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">NCIIPC</a>
          </div>
        </div>
        <div>
          <h4 className="text-sm font-bold text-cyan-300 mb-4 mono uppercase tracking-widest">Emergency</h4>
          <div className="bg-white/5 backdrop-blur p-4 rounded-2xl border border-red-500/30 text-center">
            <p className="text-xs text-gray-400 mb-1">Cyber Fraud Helpline</p>
            <a href="tel:1930" className="text-4xl font-black text-red-400 mono">1930</a>
            <p className="text-xs text-gray-400 mt-1">Available 24×7</p>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-gray-500 text-sm mono">© 2026 Cyber Secure India Portal — All Rights Reserved</p>
        <p className="text-gray-500 text-xs mono">Designed for CCS NIAM, Jaipur</p>
      </div>
    </div>
  </footer>
);

export default Footer;
